import React, {useState} from "react";
import { getWithExpiry } from "../../../common";
import TabContainer from 'react-bootstrap/TabContainer';
import TabContent from 'react-bootstrap/TabContent';
import TabPane from 'react-bootstrap/TabPane';
import jobbet from "./jobbet";
import myself from "./myself";
import hemma from "./hemma";
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";
import { useSelector } from "react-redux";
import { StickyContainer, Sticky } from 'react-sticky';
import GrayToGoldLinear from "../Charts/GrayToGoldLinear";

const GraTillGuldResults = ( props ) => {

    let answersData = props.allData;
    const [tabKey, setTabKey] = useState('jobbet');
    const [cookies] = useCookies(["sustainyou_user_jwt"]);

    const userG2gData = useSelector((state) => state?.userdata?.allUserData?.g2g_recent);

    const colors = ['white', 'sy-gray', 'sy-bronze', 'sy-silver', 'sy-gold'];
    const colorNames = ['', 'Grå', 'Brons', 'Silver', 'Guld'];

    const answerTypes = [
        {
            id: 'jobbet',
            title: 'Jobbet',
            color: 'jobb',
            questions: jobbet,
        },
        {
            id: 'myself',
            title: 'Mig själv',
            color: 'secondary',
            questions: myself,
        },
        {
            id: 'hemma',
            title: 'Hemma',
            color: 'hemma',
            questions: hemma,
        },
    ];

    let updatedData = {};

    if ( ! props.allData ) {

        if ( cookies.sustainyou_user_jwt ) {

            const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);
            const savedData = getWithExpiry(`temp_g2g_user${jwtDecoded.id}`);

            if ( savedData ) {
                updatedData = savedData;
            }

        }

        if ( updatedData && Object.keys(updatedData).length > 0 ) {
            answersData = updatedData;
        } else {
            answersData = userG2gData;
        }
    }

    return (
        <div className="gtg-results-wrap">
            <h1 className="mb-3 mb-lg-5">Resultat</h1>

            <div className="my-4">
                <GrayToGoldLinear />
            </div>

            <StickyContainer>

                <TabContainer activeKey={tabKey} onSelect={(k) => setTabKey(k)}>

                <Sticky>
                                                    
                    {({ style, isSticky }) => 
                        <div style={style} className={`${isSticky ? 'btns-is-sticky py-3' : ''} d-flex`}>

                            { answerTypes?.map( ( type, index ) => {

                                return (
                                    <div className={`d-flex flex-column result-tab position-relative align-items-center px-3 py-2 px-lg-5 py-lg-3 text-white bg-${type.color} me-2 me-lg-3 ${ tabKey === type.id ? 'active': ''}`} key={index} onClick={() => setTabKey(type.id)}>
                                        <span className="mb-2 h3">{type.title}</span>
                                    </div>
                                )
                                
                            })}
                        </div>
                    }
                </Sticky>

                    <div className="gtg-summary">

                        { answersData?.jobbet && answersData?.myself && answersData?.hemma &&
                            <>
                                { answerTypes?.map( ( type, typeIndex ) => {
                                    
                                    return (
                                        <TabContent key={typeIndex}>
                                            <TabPane eventKey={type.id}>
                                                <div className="table-responsive">
                                                    <table className="table table-hover table-striped mb-6">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th></th>
                                                                { answersData[type.id]?.answers?.map( (item, index ) => {
                                                                    const date = item.date.split('-');
                                                                    const formatter = new Intl.DateTimeFormat('sv', { month: 'short' });
                                                                    const month = formatter.format(new Date(item.date));
                                        
                                                                    return (
                                                                        <th scope="col" className="text-center" key={index}>{`${date[2]} `}<span className="text-capitalize">{month}</span></th>
                                                                    );
                                                                }) }
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            { type.questions?.map( (item, qindex) => {
                                                                return (
                                                                    <tr className="align-middle" key={qindex}>
                                                                        <th scope="row">{qindex+1}.</th>
                                                                        <th>{item.q}</th>
                                                                        { answersData[type.id]?.answers?.map( (item, index ) => {
                                                                            return (
                                                                                <td className="text-center" key={index}>
                                                                                    <div className="d-flex justify-content-center">
                                                                                        <div className={`active gtg-answer rounded-circle bg-${colors[item.answers[qindex]?.a]} text-white d-flex align-items-center justify-content-center text-uppercase font-size-medium`}>{colorNames[item.answers[qindex]?.a]}</div>
                                                                                    </div>
                                                                                </td>
                                                                            );
                                                                        }) }
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </TabPane>
                                        </TabContent>
                                    )

                                })}
                            </>
                        }

                    </div>

                </TabContainer>

            </StickyContainer>

        </div>
    );

}

export default GraTillGuldResults;